import React from "react";
import "./Professional.css";
import ProfessionalImage from "../../../../assets/images/professional-section.png";
import ProfDots from "../../../../assets/images/aboutus-dots.png";
const Professional = () => {
  return (
    <div className="professional_section">
      <img src={ProfDots} alt="" className="professional__section_dots" />
      <div className="professional__section_left">
        <div className="professional__secleft_heading">Professional</div>
        <div className="professional__secleft_description">
          <p>
            We feel it is extremely important to serve our clients and keep
            evolving when it comes to our technical expertise and financial
            knowledge.
          </p>
          <p>
            If you’re looking for your professional tax filing requirements to
            be taken care of, our firm offers a wide range of services to both
            individual and business clients. Some of the services we provide
            include accounting and bookkeeping, tax preparation and tax
            planning, and small business and financial consulting.
          </p>
          <p>
            Our team makes it a point to be available 24/7 and be able to
            provide insightful advice to enable clients to make informed
            financial decision.
          </p>
        </div>
      </div>
      <div className="professional__section_right">
        <img
          src={ProfessionalImage}
          alt=""
          className="professional__section_img"
        />
      </div>
    </div>
  );
};

export default Professional;
